export class ListSapSourcesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListSapSourcesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortSapSourceBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSapSourcesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
